import { Route } from 'react-router-dom';
import Links from './links';
import GuestRoute from '../../routes/GuestRoute';
import LoggedRoute from '../../routes/LoggedRoute';
import LoginForm from '../login/Form';
import Dashboard from '../dashboard';
import OrderPage from '../orderPage';
import { useMemo } from 'react';
import Result from '../staticResult/result';

const useHealthCheckRoutes = (): Array<React.ReactElement> => {
  const publicRoutes = useMemo(() => {
    const routes = [
      <GuestRoute
        key="signIn"
        path={Links.signIn}
        redirectLoggedTo={Links.dashboard}
        component={LoginForm}
      />,
      <Route key="certificate" path={Links.certificate} component={Result} />,
    ];

    return routes;
  }, []);

  const adminRoutes = useMemo(() => {
    const routes = [
      <LoggedRoute
        key="dashboard"
        path={Links.dashboard}
        component={Dashboard}
      />,
      <LoggedRoute key="order" path={Links.order} component={OrderPage} />,
    ];

    return routes;
  }, []);

  return [...publicRoutes, ...adminRoutes];
};

export default useHealthCheckRoutes;
